import { Pipe, PipeTransform } from '@angular/core';
import { DataFormatter } from '../services/common/DataFormatter';

@Pipe({
  name: 'formatText',
  standalone: true
})
export class FormatTextPipe implements PipeTransform {
  
  constructor(private dataFormatter: DataFormatter){}
  transform(value: any): string {
    return this.dataFormatter.format(value);
  }
}
